import { useEffect } from "react";

// Mui
import { Grid } from "@mui/material";

// Components
import { Charts } from "./Charts";

// Service
import { insightRegisterEvent } from "services";

const ProjectionBody = (): JSX.Element => {
    useEffect(() => {
        const data = async () => {
            try {
                await insightRegisterEvent();
            } catch (error) {
                console.error(error);
            }
        };
        data();
    }, []);

    return (
        <Grid container sx={{ height: "100%" }}>
            <Charts />
        </Grid>
    );
};

export default ProjectionBody;
